import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function RouteScroll() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) { window.scrollTo({ top: 0, behavior: 'instant' }); return; }
        let id;
        try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
        const reveal = () => {
            const target = document.getElementById(id);
            if (!target) return false;
            target.scrollIntoView({ block: 'start', behavior: 'instant' });
            return true;
        };
        if (reveal()) return;
        // Lazy routes mount after location changes; wait for the actual target.
        const observer = new MutationObserver(() => { if (reveal()) observer.disconnect(); });
        observer.observe(document.body, { childList: true, subtree: true });
        const timeout = window.setTimeout(() => observer.disconnect(), 10000);
        return () => { observer.disconnect(); window.clearTimeout(timeout); };
    }, [pathname, hash]);
    return null;
}
